var React = require('react');

function TransparentFilled01Inline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"18","cy":"18","r":"18","fill":"white","fillOpacity":"0.2","key":0}),React.createElement("path",{"d":"M18 19.4299C19.7231 19.4299 21.12 18.0331 21.12 16.3099C21.12 14.5868 19.7231 13.1899 18 13.1899C16.2769 13.1899 14.88 14.5868 14.88 16.3099C14.88 18.0331 16.2769 19.4299 18 19.4299Z","stroke":"white","strokeWidth":"1.5","key":1}),React.createElement("path",{"d":"M9.62001 14.49C11.59 5.83 24.42 5.84 26.38 14.5C27.53 19.58 24.37 23.88 21.6 26.54C19.59 28.48 16.41 28.48 14.39 26.54C11.63 23.88 8.47001 19.57 9.62001 14.49Z","stroke":"white","strokeWidth":"1.5","key":2})]);
}

TransparentFilled01Inline.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = TransparentFilled01Inline;

TransparentFilled01Inline.default = TransparentFilled01Inline;
